<template>
  <header class="header">
    <div class="wrapper">
      <div class="flex">
        <div class="flex-left">
          <router-link to="/" class="logo">
            <img src="./../images/logo.svg" class="img" />
          </router-link>
        </div>
        <div class="flex-right">
          <Nav />
          <div class="header-profile" v-if="$parent.isAuth">
            <div class="select-container cart" v-if="hasMultipleCurrencies">
              <select
                class="select currency-select"
                v-model="curr"
                @change="selectCurr()"
              >
                <option :value="item" v-for="item in currOptions" :key="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <div
              v-if="hasMultipleLanguages"
              class="select-container language-select-container"
            >
              <Select2
                class="select2 single language-select"
                :options="languages"
                :model-value="currentLanguageId"
                :settings="{ dropdownCssClass: 'language-select-dropdown' }"
                :placeholder="currentLanguageName"
                @select="selectLanguage($event)"
              />
            </div>
            <!-- <div class="balance-block">
              <div class="title small">{{ $parent.userBalance }} {{ $parent.currency }}</div>
            </div> -->
            <!--            <router-link to="/cart" class="button cart">-->
            <!--              <img class="img" src="./../images/cart.svg"/>-->
            <!--              <div v-if="$parent.cartContents && $parent.cartContents.length" class="indicator">-->
            <!--                {{ $parent.cartContents.length }}-->
            <!--              </div>-->
            <!--            </router-link>-->
            <a
              @click.prevent="$parent.openTopUpModal()"
              class="button cart topup-balance"
            >
              <img class="img" src="./../images/top_up.svg" />
              <div v-if="$parent.userBalance">RO {{ $parent.userBalance }}</div>
            </a>
            <router-link class="profile-desc" to="/profile/my-orders">
              <div class="icon">
                <img class="img" src="./../images/user.svg" />
              </div>
            </router-link>
          </div>
          <div v-else class="buttons">
            <div class="select-container" v-if="hasMultipleCurrencies">
              <select
                class="select currency-select"
                v-model="curr"
                @change="selectCurr()"
              >
                <option :value="item" v-for="item in currOptions" :key="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <div
              v-if="hasMultipleLanguages"
              class="select-container language-select-container"
            >
              <Select2
                class="select2 single language-select"
                :options="languages"
                :model-value="currentLanguageId"
                :settings="{ dropdownCssClass: 'language-select-dropdown' }"
                :placeholder="currentLanguageName"
                @select="selectLanguage($event)"
              />
            </div>
            <a class="desc link" @click="$emit('openSignInModal')">
              <b>{{ $t('SIGN IN') }}</b>
              <img src="./../images/link.svg" class="img" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import Nav from "../components/Nav.vue";
import Select2 from "vue3-select2-component";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "Header",
  props: ["currencyCode", "currencyValue", "categories", "currencyOptions"],
  components: {
    Nav,
    Select2,
  },
  data: function () {
    return {
      curr: "",
    };
  },
  computed: {
    ...mapState({
      languages: ({ app: { languages } }) =>
        languages.map(({ id, title: text }) => ({ id, text })),
      currentLanguage: (state) => state.app.currentLanguage,
    }),
    ...mapGetters("app", ["currentLanguageName"]),
    hasMultipleLanguages() {
      return this.languages.length > 1;
    },
    // Select2 matches option ids as strings; the store keeps the id as it came
    // from localStorage or the API, so normalise it or nothing gets preselected.
    currentLanguageId() {
      return this.currentLanguage == null ? "" : String(this.currentLanguage);
    },
    currOptions() {
      const list =
        this.currencyOptions ||
        (this.$parent && this.$parent.currencyOptions) ||
        [];
      return list.map((item) =>
        item && typeof item === "object" && item.code ? item.code : item,
      );
    },
    hasMultipleCurrencies() {
      return this.currOptions.length > 1;
    },
  },
  watch: {
    currencyCode: function (newValue) {
      this.curr = newValue;
    },
  },
  mounted() {
    const saved = localStorage.getItem("currency");
    this.curr = this.currencyCode || saved || "";
  },
  methods: {
    openSignInModal() {
      this.$emit("openSignInModal");
    },
    openSignUpModal() {
      this.$emit("openSignUpModal");
    },
    scrollToSection(section) {
      this.$emit("scrollToSection", section);
    },
    selectCurr() {
      this.changeCurrency(this.curr);
      localStorage.setItem("currency", this.curr);
    },
    changeCurrency(item) {
      this.$emit("changeCurrency", item);
    },
    // Select2 is a Vue 3 component (modelValue / update:modelValue), so v-model
    // does nothing under Vue 2 — its "select" event is the only working hook.
    selectLanguage(option) {
      if (option && option.id) {
        this.changeLocale(option.id);
      }
    },

    ...mapMutations("app", ["setCurrentLanguage"]),
    ...mapActions("app", ["changeLocale"]),
  },
};
</script>
